import React from 'react';
import {   Table, Icon, List, Popup } from 'semantic-ui-react';
import { Link } from "react-router-dom";


const CursoTipoMonedaRow=({cursotipomoneda, onShowModalBorrar, onShowModalActivar, color,form, permisos})=>{
    return (
    <Table.Row>
                        <Table.Cell>{cursotipomoneda.descripcion}</Table.Cell>
                        <Table.Cell>{cursotipomoneda.moneda}</Table.Cell>
                        <Table.Cell>{cursotipomoneda.monto}</Table.Cell>
                        <Table.Cell textAlign="center">{cursotipomoneda.estatus}</Table.Cell>
                        <Table.Cell textAlign="center">
                            <List horizontal>
                                <List.Item>
                                    <Link to={"/cursotipomoneda/"+cursotipomoneda.id}> 
                                     <Popup
                                        trigger={<Icon  name='edit outline' link   size="large"  color="tela" ></Icon>}
                                        content='Editar'
                                       
                                      />
                                     </Link> 
                                    
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='trash alternate outline' link 
                                            onClick={()=>onShowModalBorrar(cursotipomoneda.id)} 
                                            size="large" color="red"  />
                                        }
                                        content='Borrar'
                                      />
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name={cursotipomoneda.idEstatus==1?'x':'check'} link  size="large" 
                                                color={cursotipomoneda.idEstatus==1?"orange":"green"}  
                                                onClick={()=>onShowModalActivar(cursotipomoneda.id)} 
                                            />
                                        }
                                        content={cursotipomoneda.idEstatus==1?'Inactivar':'Activar'}
                                      />  
                                    
                                </List.Item>
                            </List>
                    </Table.Cell>
                      
        </Table.Row>
    
    )
}


export default CursoTipoMonedaRow;